import { render, staticRenderFns } from "./ProductContent.vue?vue&type=template&id=55730b37&scoped=true&"
import script from "./ProductContent.vue?vue&type=script&lang=ts&"
export * from "./ProductContent.vue?vue&type=script&lang=ts&"
import style0 from "./ProductContent.vue?vue&type=style&index=0&id=55730b37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55730b37",
  null
  
)

export default component.exports